import React from 'react';
import { Button } from '../ui/button';
import { Alert, AlertDescription } from '../ui/alert';
import { Check, RotateCcw, Loader2, ShieldAlert } from 'lucide-react';
import { GPS_CONFIG } from '../../hooks/useNativeGps';

export const ActionButtons = ({ photo, isGpsValid, location, submitting, absenType, onSubmit, onRetake }) => {
  if (!photo) {
    return (
      <p className="text-center text-gray-500 text-sm">
        Posisikan wajah dalam lingkaran dan tekan tombol kamera
      </p>
    );
  }

  return (
    <>
      {!isGpsValid && location && (
        <Alert className="border-red-200 bg-red-50">
          <ShieldAlert className="w-4 h-4 text-red-600" />
          <AlertDescription className="text-red-700 text-sm">
            <strong>Tidak dapat melanjutkan:</strong> Akurasi GPS ({Math.round(location.accuracy)}m) melebihi batas maksimal ({GPS_CONFIG.MAX_ACCURACY_METERS}m).
            Klik &quot;Refresh GPS&quot; di atas dan pastikan berada di tempat terbuka.
          </AlertDescription>
        </Alert>
      )}

      <Button
        className={`w-full h-14 font-bold text-lg ${
          isGpsValid
            ? 'bg-emerald-600 hover:bg-emerald-700 text-white'
            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
        }`}
        onClick={onSubmit}
        disabled={submitting || !location || !isGpsValid}
        data-testid="submit-absensi-btn"
      >
        {submitting ? (
          <><Loader2 className="w-5 h-5 mr-2 animate-spin" /> Menyimpan...</>
        ) : !isGpsValid ? (
          <><ShieldAlert className="w-5 h-5 mr-2" /> GPS Tidak Valid - Refresh GPS</>
        ) : (
          <><Check className="w-5 h-5 mr-2" /> Simpan Absensi {absenType === 'masuk' ? 'Masuk' : 'Pulang'}</>
        )}
      </Button>
      <Button
        variant="outline"
        className="w-full h-12 border-indigo-200"
        onClick={onRetake}
        disabled={submitting}
      >
        <RotateCcw className="w-4 h-4 mr-2" /> Ambil Ulang Foto
      </Button>
    </>
  );
};
